import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminAPI } from "../api";
import { toast } from "react-toastify";
import i18next from "i18next";

export const changeDistanceOfMarathon = createAsyncThunk(
  "marathon/changeDistance",
  async (query: any, { rejectWithValue }) => {
    try {
      const res = await adminAPI.changeDistanceOfMarathon(query);
      if (res.data.paymentUrl === null) {
        window.location.reload();
      } else if (res.data.paymentUrl) {
        window.location.href = res.data.paymentUrl;
      }
      const successMessage = i18next.t("changeDistance.successMessage");
      if (typeof successMessage === 'string') {
        toast.success(successMessage);
      }
      return res.data;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.title || "Произошла ошибка при изменении дистанции марафона";
      toast.error(errorMessage);
      return rejectWithValue(error);
    }
  }
);